import classes from './Statistics.module.css';
import CustomBackground from "../../components/UI/CustomBackground/CustomBackground";
import SearchFormContainer from "../../components/UI/SearchFormContainer/SearchFormContainer";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next"
import { withRouter } from "react-router-dom";
import { backgroundImages } from "../../shared/utility";

import { useMatomo } from '@datapunt/matomo-tracker-react';
const Statistics = (props: any) => {
  const { trackPageView } = useMatomo();

  React.useEffect(() => {
    trackPageView({documentTitle: "Statistics"});

    window.scrollTo({top: 0, behavior: 'smooth'});
    // eslint-disable-next-line
  }, []);

  const { t } = useTranslation();

  const tableauUrl = "https://public.tableau.com/views/ContentVF_Statisticforwebsite_16397512901350/Database" +
    "?:embed=y&amp;:display_count=yes&amp;:showVizHome=no&amp;:host_url=https%3A%2F%2Fpublic.tableausoftware.com%2F&amp;:tabs=yes&amp;:toolbar=no&amp;" +
    ":animate_transition=yes&amp;:display_static_image=no&amp;:display_spinner=yes&amp;:display_overlay=yes&amp;:display_count=yes&amp;:loadOrderID=0";

  return (
    <>
      <CustomBackground  image={backgroundImages.VARIETIES}>
        <SearchFormContainer
          title={t("menu.footer.statistics")}
          subtitle={t("menu.footer.statistics_subtitle")}
          >
          <Form className={classes.searchForm}>
            <Row>
              <Col md="12">
                <iframe
                  src={tableauUrl}
                  allowFullScreen={true}
                  className="tableauViz"
                  frameBorder={0}
                  marginHeight={0}
                  marginWidth={0}
                  style={{
                    display: "block",
                    margin: "auto",
                    padding: "0px",
                    border: "none",
                    width: "815px",
                    height: "1150px",
                    borderRadius: "4px",
                  }}
                />
              </Col>
            </Row>
          </Form>
        </SearchFormContainer>
      </CustomBackground>
    </>
  )
}

export default withRouter(Statistics);
